import Flickity from "flickity";

export default function () {

    const hero = document.querySelector('.js-hero-slider');
    const blogSlider = document.querySelector('.js-blog-slider');

    if (hero) {
        const flkty = new Flickity( hero , {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: 3000,
            pageDots: true,
            draggable: true,
        });
    }

    if (blogSlider) {
        const flkty = new Flickity( blogSlider , {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: true,
            autoPlay: false,
            pageDots: false,
            draggable: true,
        });
    }

}
